module.exports = __webpack_public_path__ + "static/img/logisticsCar.f8924807.png";